var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    [
      _c(
        "b-row",
        { staticClass: "color_config_header" },
        [
          _c("b-col", { staticClass: "text-left", attrs: { cols: "9" } }, [
            _c("h4", [_vm._v(_vm._s(_vm.$t("CONFIGURED.RANGE")))])
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "text-center", attrs: { cols: "3" } }, [
            _c("h4", [_vm._v(_vm._s(_vm.$t("CONFIGURED.COLOR")))])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        staticClass: "config-table",
        attrs: {
          "show-empty": "",
          "empty-text": _vm.$t("COMMON.NO_RECORD"),
          items: _vm.rangeColors,
          fields: _vm.fields,
          "thead-class": "hidden_header"
        },
        scopedSlots: _vm._u([
          {
            key: "color_code",
            fn: function(data) {
              return [
                _c("range", {
                  attrs: {
                    start: data.item.min_range,
                    end: data.item.max_range,
                    color: data.item.color_code
                  },
                  on: {
                    colorSelected: function($event) {
                      data.item.color_code = $event
                    }
                  }
                })
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "div",
        { attrs: { slot: "footer", align: "center" }, slot: "footer" },
        [
          _c(
            "b-button",
            {
              staticClass: "button-style",
              attrs: { type: "reset", variant: "gray" },
              on: { click: _vm.resetColors }
            },
            [
              _c("i", { staticClass: "fa fa-ban" }),
              _vm._v(" " + _vm._s(_vm.$t("COMMON.RESET")))
            ]
          ),
          _vm._v(" "),
          _c(
            "b-button",
            {
              staticClass: "button-style",
              attrs: { type: "submit", variant: "secondary" },
              on: { click: _vm.updateColors }
            },
            [
              _c("i", { staticClass: "fa fa-save" }),
              _vm._v(" " + _vm._s(_vm.$t("COMMON.SAVE")) + " ")
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-07e6a3b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07e6a3b4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/confidenceColors.vue
// module id = 1324
// module chunks = 2